import * as React from 'react'
import { Global } from '@emotion/react'

const GlobalStyles = () => {
  return (
    <>
      <Global
        styles={
          {
            // map the imorted styles to the existing css classes or html tags
          }
        }
      />
    </>
  )
}

export default GlobalStyles
